import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const credentialsV2Navbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.credentials_v2_drp, {
      displayName: 'Account Takeover Prevention',
      icon: SolIcon.asm_credentials,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(PrototypeRouteId.credentials_v2_credentials, {
          displayName: 'Exposed accounts',
          children: [
            SolNavbarItem.of(PrototypeRouteId.credentials_v2_credential_detail, {
              displayName: 'Exposed account detail',
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_credential_detail_overview, {
                  displayName: 'Overview',
                }),
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_credential_detail_scoring, {
                  displayName: 'Scoring',
                }),
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_credential_detail_activity, {
                  displayName: 'Activity',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(PrototypeRouteId.credentials_v2_cookies, {
          displayName: 'Exposed cookies',
          children: [
            SolNavbarItem.of(PrototypeRouteId.credentials_v2_cookie_detail, {
              displayName: 'Exposed cookie detail',
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_cookie_detail_overview, {
                  displayName: 'Overview',
                }),
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_cookie_detail_scoring, {
                  displayName: 'Scoring',
                }),
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_cookie_detail_activity, {
                  displayName: 'Activity',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(PrototypeRouteId.credentials_v2_exposures, {
          displayName: 'Exposure artifacts',
          children: [
            SolNavbarItem.of(PrototypeRouteId.credentials_v2_exposure_detail, {
              displayName: 'Exposure artifact detail',
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_exposure_detail_overview, {
                  displayName: 'Overview',
                }),
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_exposure_detail_scoring, {
                  displayName: 'Scoring',
                }),
                SolNavbarItem.of(PrototypeRouteId.credentials_v2_exposure_detail_activity, {
                  displayName: 'Activity',
                }),
              ],
            }),
          ],
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
